///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2025
//                                  RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { stringify } from "query-string";

import { API, CancelToken } from "../api/axios";
import messages from "../helpers/messages";

export const getPricingLanes = (bidId, userRoleForLanesWhenManagementUser) =>
  API.get("api/v1.0/lanes", {
    params: { bidId, userRoleForLanesWhenManagementUser }
  });

export const getRxoTruckloadLanePricingFilterFacets = (
  bidId,
  userRoleForLanesWhenManagementUser
) =>
  API.get("api/v1.0/lanes/rxo-truckload-pricing/filter-facets", {
    params: { bidId, userRoleForLanesWhenManagementUser }
  });

export const searchRxoTruckloadLanesForPricingPaged = body =>
  API.post("api/v1.0/lanes/rxo-truckload-pricing/search", body);

export const getLanesTemplate = (
  division,
  mode,
  templateVersion,
  enableTruckloadLaneImportV2
) =>
  enableTruckloadLaneImportV2
    ? API.get("api/v1.0/lanes/template", {
        params: { division, mode, templateVersion },
        responseType: "blob"
      })
    : API.get("api/v1.0/lanes/template", {
        params: { division, mode },
        responseType: "blob"
      });

export const postLanes = (
  bidId,
  file,
  config,
  userRoleForLanesWhenManagementUser
) => {
  var formData = new FormData();

  formData.append("bidId", bidId);
  formData.append("lanes", file);
  userRoleForLanesWhenManagementUser &&
    formData.append(
      "userRoleForLanesWhenManagementUser",
      userRoleForLanesWhenManagementUser
    );

  return API.post("api/v1.0/lanes", formData, config);
};

export const getLanesTemplateWithData = ({
  bidId,
  userRoleForLanesWhenManagementUser
}) =>
  API.get(`api/v1.0/lanes/template-with-lane-data`, {
    params: { bidId, userRoleForLanesWhenManagementUser },
    responseType: "blob"
  });

export const getTLLaneCountByRegion = bidId =>
  API.get("api/v1.0/Lanes/tl-lane-count-by-region", {
    params: { bidId }
  });

export const putAssignTruckloadLanes = regionsToAssign =>
  API.put("api/v1.0/Lanes/truckload-lane-assignments", regionsToAssign);

export const patchTruckloadEditedlanes = (bidId, laneEdits) => {
  return API.patch("api/v1.0/lanes/truckload", { bidId, laneEdits });
};

export const postImportAwards = (
  bidId,
  file,
  config,
  userRoleForLanesWhenManagementUser
) => {
  var formData = new FormData();

  formData.append("bidId", bidId);
  formData.append("lanes", file);
  userRoleForLanesWhenManagementUser &&
    formData.append(
      "userRoleForLanesWhenManagementUser",
      userRoleForLanesWhenManagementUser
    );

  return API.post("api/v1.0/lanes/import-awards", formData, config);
};

export const putBulkEdit = (
  bidId,
  file,
  config,
  userRoleForLanesWhenManagementUser
) => {
  var formData = new FormData();

  formData.append("bidId", bidId);
  formData.append("lanes", file);
  userRoleForLanesWhenManagementUser &&
    formData.append(
      "userRoleForLanesWhenManagementUser",
      userRoleForLanesWhenManagementUser
    );

  return API.put("api/v1.0/lanes/bulk-edit", formData, config);
};

export const getAwardedLanes = bidId =>
  API.get("api/v1.0/lanes/awarded-lanes", {
    params: { bidId },
    responseType: "blob"
  });

export const getShipperRatesAwardedLanes = settings =>
  API.post(
    "api/v1.0/lanes/awarded-lanes-shipper-rates-export",
    {
      bidId: settings.bidId,
      commitmentPeriod: +settings.commitmentPeriod,
      includeNonPrimaryAwardedLanes: settings.includeNonPrimary,
      replaceVanEquipmentTypeWithVanReefer: settings.replaceV
    },
    { responseType: "blob" }
  );

export const deleteLane = (request, userRoleForLanesWhenManagementUser) => {
  return API.delete("api/v1.0/lanes/single", {
    data: request,
    params: { userRoleForLanesWhenManagementUser }
  });
};

export const deleteLanes = (request, userRoleForLanesWhenManagementUser) => {
  return API.delete("api/v1.0/lanes/all", {
    data: request,
    params: { userRoleForLanesWhenManagementUser }
  });
};

export const getIsLaneUploadInProgress = (
  bidId,
  userRoleForLanesWhenManagementUser
) =>
  API.get("api/v1.0/lanes/upload-in-progress", {
    params: { bidId, userRoleForLanesWhenManagementUser }
  });

export const getLaneErrorDocument = (
  bidId,
  uploadId,
  userRoleForLanesWhenManagementUser
) =>
  API.get(`api/v1.0/lanes/error-document`, {
    params: { bidId, uploadId, userRoleForLanesWhenManagementUser },
    responseType: "blob"
  });

export const getTruckloadMatchLanesCount = (truckloadLaneIds, bidId) => {
  return API.post("/api/v2.0/lanes/truckload-match-counts", {
    truckloadLaneIds,
    bidId
  });
};

export const getTruckloadMatchLanesCountV3 = (
  truckloadLaneIds,
  bidId,
  filters
) => {
  return API.post("/api/v3.0/lanes/truckload-match-counts", {
    truckloadLaneIds,
    bidId,
    ...filters
  });
};

export const getTruckloadLaneHasMatches = (
  truckloadLaneIds,
  bidId,
  filters
) => {
  return API.post("/api/v1.0/lanes/truckload-has-matches", {
    truckloadLaneIds,
    bidId,
    ...filters
  });
};

let cancelGetMatchingLanesToken;
export const getMatchingLanes = (filters, truckloadLaneId, bidId) => {
  if (cancelGetMatchingLanesToken) {
    cancelGetMatchingLanesToken(messages.cancelledByUser.defaultMessage);
  }

  return API.get("api/v2.0/lanes/truckload-matches", {
    params: { ...filters, truckloadLaneId, bidId },
    paramsSerializer: params => stringify(params),
    cancelToken: new CancelToken(function executor(cancelToken) {
      cancelGetMatchingLanesToken = cancelToken;
    })
  });
};

export const patchLaneMatchEdits = tlLaneEditRequests => {
  return API.patch("api/v1.0/lanes/truckload-matches", {
    tlLaneEditRequests
  });
};

export const getSpecificLanes = (bidId, laneIds) =>
  API.post("/api/v2.0/lanes/truckload-pricing", {
    bidId,
    laneIds
  });

export const getSpecificMatchingLanes = (bidId, laneIds) =>
  API.post("/api/v2.0/lanes/truckload-matching", {
    bidId,
    laneIds
  });

export const patchEuTruckloadEditedlanes = (bidId, laneEdits) =>
  API.patch("api/v1.0/lanes/eu-truckload", { bidId, laneEdits });

export const patchEuLaneMatchEdits = europeTLLaneEditRequests =>
  API.patch("api/v1.0/lanes/eu-truckload-matches", {
    europeTLLaneEditRequests
  });

export const getIsLanePriceInProgress = (
  bidId,
  userRoleForLanesWhenManagementUser
) =>
  API.get("api/v1.0/lanes/price-in-progress", {
    params: { bidId, userRoleForLanesWhenManagementUser }
  });

export const getRevenue = bidId =>
  API.get("api/v1.0/lanes/get-revenue", {
    params: { bidId }
  });

export const getAggregatedPricingForecastForLane = request =>
  API.post("api/v1.0/Lanes/get-aggregated-pricing-forecast-for-lane", request);

export const getShipperRatesForLane = request =>
  API.post("api/v1.0/Lanes/get-shipper-rates-for-lane", request);

export const getLaneExportDocument = (
  bidId,
  userRoleForLanesWhenManagementUser,
  uploadId
) =>
  API.get(`api/v1.0/lanes/export-document`, {
    params: { bidId, uploadId, userRoleForLanesWhenManagementUser },
    responseType: "blob"
  });

export const getLanesTemplateWithDataV2 = ({
  bidId,
  userRoleForLanesWhenManagementUser
}) =>
  API.get(`api/v1.0/lanes/template-with-lane-data-v2`, {
    params: { bidId, userRoleForLanesWhenManagementUser }
  });

export const getAwardedLanesV2 = bidId =>
  API.get("api/v1.0/lanes/trigger-award-management-export", {
    params: { bidId }
  });

export const getAwardManagementExportDocument = (bidId, uploadId) =>
  API.get(`api/v1.0/lanes/award-management`, {
    params: { bidId, uploadId },
    responseType: "blob"
  });

export const postImportAwardsV2 = (
  bidId,
  file,
  config,
  userRoleForLanesWhenManagementUser
) => {
  var formData = new FormData();

  formData.append("bidId", bidId);
  formData.append(
    "userRoleForLanesWhenManagementUser",
    userRoleForLanesWhenManagementUser ?? 0
  );
  formData.append("lanes", file);

  return API.post("api/v1.0/lanes/import-awards-v2", formData, config);
};
